import { useModal } from "../../../../hooks/useModal.js";
import { useInternet } from "../../../../hooks/useInternet.js";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod/dist/zod.js";
import * as zod from "zod";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Modal } from "../../../../components/modal.jsx";
import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import { SubmitButton } from "../../../../components/fields/submitButton.jsx";
import { sessionSlice } from "../../../../slices/sessionSlice.jsx";
import { useNavigate } from "react-router-dom";
import { useResource } from "../../../../hooks/useResource.js";

export const ACCOUNT_SWITCH_MODAL = "account-switch-modal";

export function AccountSwitchModal() {
  let { closeModal } = useModal();
  let internet = useInternet();
  let { formState, control, handleSubmit, reset } = useForm({
    resolver: zodResolver(zod.object({ name: zod.string().min(1) })),
  });
  let session = useSelector((state) => state.session);
  let dispatch = useDispatch();
  let [loading, setLoading] = useState(false);
  let [accounts, setAccounts] = useState([]);
  let navigate = useNavigate();
  let switchTo = (account) => {
    internet
      .post("/switchaccount", { account: account.id })
      .then(async (res) => {
        let { token, user, account, stats } = await res.json();
        window.localStorage.token = token;
        navigate("/");
        dispatch(sessionSlice.actions.setData({ user, account, stats }));
        closeModal(ACCOUNT_SWITCH_MODAL);
      });
  };
  let accountService = useResource("accounts");
  useEffect(() => {
    setLoading(true);
    accountService.list().then((res) => {
      setAccounts(res);
      setLoading(false);
    });
  }, []);
  let create = (d) => {
    return accountService.create(d).then((res) => {
      setAccounts([...accounts, res]);
      reset({});
    });
  };
  return (
    <Modal onClose={() => closeModal(ACCOUNT_SWITCH_MODAL)}>
      {loading ? (
        <div>
          <span className={"fa fa-spinner fa-spin"} />
        </div>
      ) : (
        <div className={"flex flex-col gap-3"}>
          <p>You are currently linked to the following accounts:</p>
          {accounts.map((acc) => (
            <div
              onClick={() => switchTo(acc)}
              className={
                "bg-blue-50 hover:bg-blue-100 cursor-pointer rounded p-3 " +
                (acc.id == session.account.id && "font-medium")
              }
            >
              {acc.companyName}
              {acc.id == session.account.id && "*"}
            </div>
          ))}
          <form onSubmit={handleSubmit(create)} className={"flex gap-3"}>
            <SimpleField name={"name"} control={control} placeholder={"Name"} />
            <SubmitButton formState={formState}>Create</SubmitButton>
          </form>
        </div>
      )}
    </Modal>
  );
}
